import {createReducer} from 'redux-act';
import {ForecastPageData, ForecastViewParams} from '@/app/interfaces/weather';
import * as actions from './actions';
import {ForecastDaysMode} from '@/app/constants/forecast';

const initialState = {
	// All data is required to display the forecast page for a specific location
	data: <null | ForecastPageData>null,

	view: <ForecastViewParams>{
		daysMode: ForecastDaysMode.Days7,
	},
};

export const forecastReducer = createReducer({}, initialState);

forecastReducer
	.on(actions.fetchSettlementForecastDataAction.success, (state, {data, view}) => {
		return {...state, data, view};
	})
	.on(actions.fetchMainPageForecastDataAction.success, (state, {data}) => {
		return {
			...state,
			data,
			view: {
				daysMode: ForecastDaysMode.Days7,
			},
		};
	})
	.on(actions.fetchSettlementExtraDataAction.success, (state, {countryTopLocations, regionTopLocationWeather}) => {
		return {
			...state,
			data: {
				...state.data!,
				extra: {
					type: 'settlementPage',
					countryTopLocations,
					regionTopLocationWeather,
				},
			},
		};
	})
	.on(actions.reFetchForecastDataAction.success, (state, {forecast, mode}) => {
		return {
			...state,
			data: {
				...state.data!,
				forecast:
					mode.type === 'all'
						? forecast // Full replace
						: state.data!.forecast.map(day => (day.date === forecast[0].date ? forecast[0] : day)), // Replace only the first day
			},
		};
	})
	.on(actions.setForecastViewParams, (state, newView) => {
		return {
			...state,
			view: {
				...state.view,
				...newView,
			},
		};
	});
